module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f480.f64f47a8.svg";